import _ from 'lodash'
import firebase from "firebase/app";
import "firebase/database";
import {trigger, watch, apply} from "../core"

var config = {
    apiKey: "AIzaSyC7xD4imt_iW1gNGsNV_LSe3RWToY6r3-Q",
    // authDomain: "hypernote-io.firebaseapp.com",
    databaseURL: "https://tachyon-notes.firebaseio.com/",
    // storageBucket: "bucket.appspot.com"
};
firebase.initializeApp(config);

// Get a reference to the database service
var database = firebase.database();

global.database = database;
global.firebase = firebase;

var entities = {}
global.entities = entities

export var dataLoaded;


let ref = location.pathname.match(/\/([^\/]+)/);
if(ref){
    global.dbPath = ref[1]
}else{
    history.replaceState({}, "", "/default")
    global.dbPath = 'default'
}

let workspaceRef = database.ref('users/' + global.dbPath);


export function save(buffer){
    if(_.isEqual(buffer, {})) return;

    setTimeout(() => workspaceRef.update(buffer), 10)
}



function popState(){
    let ref = location.pathname.match(/\/[^\/]+\/(.+)/)
    if(ref){
        history.no_history = true;
        quark.set_text(undefined, $$root$$, tok(ref[1]))
        history.no_history = false;
    }
}

window.onpopstate = function(event) {
    popState()
    globalUpdate()
};



workspaceRef.on('value', snap => {
    // console.log('got value', snap.val() || {})
    
    let new_snapshot = snap.val() || {};

    let delta = {}
    for(let key in new_snapshot){
        if(!_.isEqual(new_snapshot[key], entities[key])){
            delta[key] = new_snapshot[key]
        }
    }
    apply(delta)

    if(!dataLoaded){
        dataLoaded = true;
        popState()    
    }
    globalUpdate()
})



// WEBPACK FOOTER //
// ./src/quark/store/firebase.js